import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';

@Component({
  selector: 'app-employee-hours-report',
  templateUrl: './employee-hours-report.component.html',
  styleUrls: ['./employee-hours-report.component.css']
})

export class EmployeeHoursReportComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private _exportService: ExportService) { }

  formTitle = "Employee Worklog Report";

  ngOnInit(): void {
    this.loadAllAssignee();
    this.loadAllProjects(this.str);
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
  }

  dt = new Date();
  month: number;
  year: number;
  START_DATE: string;
  END_DATE: string;
  radioValue = "E";

  getMonthAndYear() {
    this.month = this.dt.getMonth();
    this.year = this.dt.getFullYear();
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["EMPLOYEE_ID", "Employee ID"],["NAME", "Name"],];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectDataForExcel = []; 
  date = new Date();

  getAllEmployeeWiseHoursDetails(reset: boolean = false) {
    var ok = true;
    if (this.MODULE_ASSIGNEE_ID.length == 0) {
      ok = false
    }
    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }

      this.loadingRecords = true;
      var sort: string;
      try {
        sort = this.sortValue.startsWith("a") ? "asc" : "desc";

      } catch (error) {
        sort = "";
      }
      if (this.searchText != "") {
        var likeQuery = " AND";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });
        likeQuery = likeQuery.substring(0, likeQuery.length - 2)
      }

      this.applyFilter();

      var filter = "";
      if (likeQuery)
        filter = this.filterQuery + likeQuery;
      else
        filter = this.filterQuery;
      this._apiService.getEmplyeeWiseWorkingHours(this.pageIndex, this.pageSize, 'NAME', sort, this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
        this.loadingRecords = false;
        this.isProjectSpinning = false;
        this.totalRecords = data['count'];
        this.projectData = data['data'];
      }, err => {
        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });
    }
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";

  applyFilter() {
    this.getMonthAndYear();
    this.getDaysOfMonth(this.month, this.year);

    this.isFilterApplied = "primary";
    this.filterClass = "filter-invisible";
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.dt = new Date();
    this.date = this.dt;

    this.projectID = [];
    this.TYPE = "";
    this.str = "";

    this.loadAllProjects(this.str);
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
    this.getAllEmployeeWiseHoursDetails(true);
    this.radioValue = "E";
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'asc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;


    if (this.MODULE_ASSIGNEE_ID.length != 0) {
      this.getAllEmployeeWiseHoursDetails();
    }
  }

  onChange(result: Date): void {
    this.dt = result;
  }

  days = new Array();

  getDaysOfMonth(MM, yyyy) {
    this.days = [];

    this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');


    this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
    this.getDaysArray(this.START_DATE, this.END_DATE);
  }

  getDaysArray(start, end) {
    for (var arr = [], dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
      arr.push(this.datePipe.transform(dt, "yyyy-MM-dd"));
      this.days.push(this.datePipe.transform(dt, "yyyy-MM-dd"));
    }
    return arr;
  };

  findTotalDays(yyyy, MM) {
    var numOfDays = new Date(yyyy, MM + 1, 0).getDate();

    var d = new Date(yyyy, MM, 1);
    this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

    var e = new Date();
    this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    for (var i = 0; i < numOfDays; i++) {
      var date = new Date(yyyy, MM, i + 1);
      if (date != null) {
        this.days[i] = this.datePipe.transform(date, 'yyyy-MM-dd');
      }
    }
  }

  onEnterGetAllEmployeeWiseHoursDetails() {
    document.getElementById('button1').focus();
    this.getAllEmployeeWiseHoursDetails(true);
  }

  loadprojectexcel: boolean = false;
  importInExcel() {
    var arry1 = [];
    var arry2 = [];
    var arry3 = [];

    var obj1: any = new Object();
    var obj2: any = new Object();
    var obj3: any = new Object();
    this.loadprojectexcel = true;
    this._apiService.getEmplyeeWiseWorkingHours(0, 0, 'NAME', 'asc', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      if (data['code'] == 200) {
        this.projectDataForExcel = data['data'];
        console.log(this.projectDataForExcel);
        this.loadprojectexcel = false;
        if (data['data'].length > 0) {
          for (var i = 0; i < this.projectDataForExcel.length; i++) {
                        obj1['Employee ID'] = this.projectDataForExcel[i]['EMPLOYEE_ID'];
console.log(this.projectDataForExcel[i]['EMPLOYEE_ID']);
            obj1['Name'] = this.projectDataForExcel[i]['NAME'];

            obj1['Total Time'] = this._apiService.convertIntoHMS(Number(this.projectDataForExcel[i]['TOTAL_SECONDS']));
            obj2['Employee ID'] = this.projectDataForExcel[i]['EMPLOYEE_ID'];

            obj2['Name'] = this.projectDataForExcel[i]['NAME'];

            obj2['Total Seconds'] = this.projectDataForExcel[i]['TOTAL_SECONDS'];

            obj3['Employee ID'] = this.projectDataForExcel[i]['EMPLOYEE_ID'];

            obj3['Name'] = this.projectDataForExcel[i]['NAME'];

            obj3['Total'] = parseFloat(String(Number(this.projectDataForExcel[i]['TOTAL_SECONDS']) / 3600)).toFixed(2);

            for (var j = 0; j < this.days.length; j++) {
              obj1[this.datePipe.transform(this.days[j], 'dd-MMM-yyyy')] = this._apiService.convertIntoHMS(Number(this.projectDataForExcel[i][this.days[j]]));
              obj2[this.datePipe.transform(this.days[j], 'dd-MMM-yyyy')] = this.projectDataForExcel[i][this.days[j]];
              obj3[this.datePipe.transform(this.days[j], 'dd-MMM-yyyy')] = parseFloat(String((Number(this.projectDataForExcel[i][this.days[j]]) / 3600))).toFixed(2);

              if (j == this.days.length - 1) {
                arry1.push(Object.assign({}, obj1));
                arry2.push(Object.assign({}, obj2));
                arry3.push(Object.assign({}, obj3));
              }
            }

            if (i == this.projectDataForExcel.length - 1) {
              this._exportService.exportExcel(arry1, 'Employee Worklog Report (HH:MM:SS)');
              this._exportService.exportExcel(arry2, 'Employee Worklog Report (In Seconds)');
              this._exportService.exportExcel(arry3, 'Employee Worklog Report');
            }
          }
        } else {
          this.notificationService.info("Data not found", "");
        }
      } else {
        this.projectDataForExcel = [];
        this.loadprojectexcel = false;
      }
    }, err => {
      this.projectDataForExcel = [];
      this.loadprojectexcel = false;
    });

  }

  assigneeList:any;
  categoryID = 0;

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;

    this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' AND IS_ACTIVE=1').subscribe(userData => {
      if (userData['code'] == 200) {
        this.assigneeList = userData['data'];
        console.log("Assignee List:", this.assigneeList);
console.log("Total Users:", this.assigneeList.length);
        var userCategory = this.assigneeList.filter(x => x.ID == this._apiService.userId);
        if (userCategory != null && userCategory != undefined) {
          this.categoryID = userCategory[0]['TASK_CATEGORY_ID'];
        } else {
          this.categoryID = 0;
        }
        this.loadAllRoles();
      }
    }, err => {
    });
  }

  roleData :any;

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;
    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(data => {
        if (data['code'] == 200) {
          this.roleData = data['data'];
          console.log("Role Data:", this.roleData);
          this.findNewAssigneeList();
          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getAllEmployeeWiseHoursDetails(true);
          }
        }

      }, err => {
      });

    } else {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', ' and LEVEL >= (' + level + ')').subscribe(data => {
        if (data['code'] == 200) {
          this.roleData = data['data'];

          this.findNewAssigneeList();
          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getAllEmployeeWiseHoursDetails(true);
          }
        }

      }, err => {
      });
    }
  }

  newAssigneeList = [];
  MODULE_ASSIGNEE_ID = [];
  TYPE = "";

  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.MODULE_ASSIGNEE_ID = [];
 console.log("Assignee List", this.assigneeList);
  console.log("Role Data", this.roleData);
    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
          console.log(
        "User:", this.assigneeList[k].NAME,
        "ROLE_IDS:", this.assigneeList[k].ROLE_IDS,
        "Role ID:", this.roleData[j].ID
      );
        if (Number(this.assigneeList[k]['ROLE_IDS']) == this.roleData[j]['ID']) {
          if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
            this.newAssigneeList.push(this.assigneeList[k]);

          } else if (this.cookie.get("level") == "4") {
            if (Number(this.assigneeList[k]['TASK_CATEGORY_ID']) == this.categoryID) {
              console.log("User:", this.assigneeList[k].NAME, "matches category ID:", this.categoryID);
              this.newAssigneeList.push(this.assigneeList[k]);
            }

          } else {
            if (Number(this.assigneeList[k]['ID']) == this._apiService.userId) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }
          }
        }
      }
      
    }

    for (var i = 0; i < this.newAssigneeList.length; i++) {
      this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['ID']);
    }
     console.log("Final List:", this.newAssigneeList);
  }

  projectID = [];
  projectList = [];

  loadAllProjects(str) {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', str).subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.projectList = projectData['data'];
        for (var i = 0; i < this.projectList.length; i++) {
          this.projectID.push(this.projectList[i]['ID']);
        }
      }
    }, err => {
    });
  }

  str = "";

  onStatusChange(type) {
    this.projectID = [];

    if (type == "B") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=1';

    } else if (type == "NB") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=0';

    } else if (type == null) {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE in (0,1)';
    }

    this.loadAllProjects(this.str);
  }

  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  startDateHandle(open: boolean) {
    this.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.END_DATE = this.START_DATE;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (this.START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var previousDate = new Date(this.START_DATE);
      previousDate.setDate(previousDate.getDate() + (-1));

      return endValue <= new Date(previousDate);
    };
  }

  changeRadioButton(radioButtonValue, apply = false) {
    if (radioButtonValue == "A") {
      let currentDate = new Date();
      this.START_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "B") {
      let currentDate = new Date();
      let previousDate = currentDate.setDate(currentDate.getDate() + (-1));

      this.START_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "C") {
      let currentDate = new Date();
      let previous6thDayDate = currentDate.setDate(currentDate.getDate() + (-6));
      let next7thDayDate = currentDate.setDate(currentDate.getDate() + (6));

      this.START_DATE = this.datePipe.transform(previous6thDayDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(next7thDayDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "D") {
      let currentDate = new Date();
      let lastMonth = currentDate.getMonth() + (-1);
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, lastMonth + 1, 0).getDate();

      let d = new Date(currentYear, lastMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, lastMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    } else if (radioButtonValue == "E") {
      let currentDate = new Date();
      let currentMonth = currentDate.getMonth();
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, currentMonth + 1, 0).getDate();

      let d = new Date(currentYear, currentMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date();
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');
    }

    if (apply) {
      this.getDaysOfMonth(this.month, this.year);
      this.applyWithRadioButtons();
    }
  }

  applyWithRadioButtons() {
    this.loadingRecords = true;
    this.pageIndex = 1;

    this._apiService.getEmplyeeWiseWorkingHours(this.pageIndex, this.pageSize, 'NAME', 'asc', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.projectData = data['data'];
    }, err => {
      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }
}
